// extracted by mini-css-extract-plugin
export default {"container":"GlitchRainText_container__IRyiO","canvas":"GlitchRainText_canvas__tHWKx"};